import { css } from 'aphrodite';
import * as React from 'react';
import { ReportsGlyph } from './inboxIcons';
import { inboxStyles as s } from './styles/inboxStyles';

interface ReportsPlaceholderProps {
	mailboxName?: string;
}

/**
 * Reports screen — placeholder for this first pass. The Claude Design prototype mocks a full
 * Assistant-impact dashboard here; wiring it to real metrics is deferred.
 */
export const ReportsPlaceholder: React.FC<ReportsPlaceholderProps> = ({ mailboxName }) => (
	<div className={css(s.reportsScreen)}>
		<div className={css(s.reportsInner)}>
			<div>
				<h1 className={css(s.reportsTitle)}>Support Reports</h1>
				{mailboxName && <div className={css(s.detailKey)}>{mailboxName}</div>}
			</div>
			<div className={css(s.reportsPlaceholderCard)}>
				<ReportsGlyph size={32} />
				<div>Reporting is coming soon.</div>
			</div>
		</div>
	</div>
);
